export enum RepeatInterval {
    EveryWeek = 604800,
    Every2Weeks = 1209600,
    Every3Weeks = 1814400,
    EveryMonth = 2419200
}
